<template>
  <b-container>
      <div class="school-list">
          <b-col class="md-5 mt-4">
              <b-table
                v-cloak
                responsive
                :fields="fields"
                :items="schools"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                @filtered="onFiltered"
                >
                <template slot="cell(school_name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditSchool', params: { id: row.item.uuid } }"
                    >{{ row.item.school_name }}</b-link
                    >
                  
                </template>
                
                <template slot="cell(active)" slot-scope="row">
                  
                  <b-form-radio-group
                    :id="row.index.toString()"
                    :value="row.item.active"
                    v-model="row.item.active"
                    @change="updateTeacherSchoolStatus(row.item)"
                    >
                    <b-form-radio :value="true">True</b-form-radio>
                    <b-form-radio :value="false">False</b-form-radio>
                    </b-form-radio-group>
                </template>
                </b-table>
                <b-row>
                    <b-col md="6" class="my-1">
                        <b-pagination
                        :total-rows="schools.length || 0"
                        :per-page="perPage"
                        v-model="currentPage"
                        class="my-0"
                        />
                    </b-col>
                </b-row>
          </b-col>
      </div>
  </b-container>
</template>
<script>
import TeacherService from "../services/TeacherService";
export default {
   name: "TeacherSchools",
   data(){
      return{
          fields: [
              { key: "school_name", label: "School", sortable: true},
              { key: "active", label: "Active" },
          
          ],
          currentPage: 1,
          perPage: 5,
          filter: null,
          schools:[]
      }
   },
   methods:{
      stopClick() {},
      onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
      },
        async updateTeacherSchoolStatus(params) {
          console.log(params);
          const payload = await {
              id: params.school_teacher_id,
              active: params.active,
          };
          await TeacherService.updateTeacherSchoolStatus(payload);
      }
   },
   async created(){
      const list =  await TeacherService.fetchTeacherSchools();
      this.schools = list.data.schools
   }
}
</script>